<template>
	<ProgressSpinner v-if="!permission"/>
	<Container class="pt-6" v-if="permission">
		<div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
			<PageHeading>{{ permission.name ?? $route.params.permission }}</PageHeading>
		</div>

		<div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
			<TabLayout :tabs="tabs" sticky/>
		</div>

		<router-view
				@on-save="$emit('on-save')"
				@on-delete="$emit('on-delete')"
				:permission="permission"
		></router-view>
	</Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { usePermissionsStore } from "@/stores/permissions.js";
import Container from "@/Components/Container.vue";


export default {
	name: "PermissionView",
	components: {Container, TabLayout, PageHeading},
	data() {
		return {
			permission: undefined,
		}
	},
	emits: [
		'on-save',
		'on-delete',
	],
	watch: {
		'$route.params.permission': {
			async handler(newValue, oldValue) {
				if(newValue){
					if(this.$route.params.permission === 'NEW'){
						this.permission = {};
					} else {
						this.permission = await this.permissionsStore.showPermission(this.$route.params.permission);
					}
				} else {
					this.permission = undefined;
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapStores(usePermissionsStore),
		tabs() {
			return [
				{
					label: this.$t('pages.admin.users.permissions.permission.permission_view.summary'),
					current: this.$route.name === 'admin.users.permissions.permission',
					to: {name: 'admin.users.permissions.permission', params: this.$route.params}
				},
				// {
				// 	name: 'Roles',
				// 	current: this.$route.name === 'admin.users.permissions.roles',
				// 	to: {name: 'admin.users.permissions.roles', params: this.$route.params}
				// },
			]
		}
	},
}
</script>